import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialKey: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23.62 4.57h1.52v7.62h-1.52Zm-1.53 21.34h1.53v1.52h-1.53Zm0-6.1h1.53v1.52h-1.53Zm0-7.62h1.53v1.52h-1.53Zm0-9.14h1.53v1.52h-1.53Zm-1.52 10.66h1.52v1.53h-1.52Zm0-12.19h1.52v1.53h-1.52Zm-3.05 25.91v3.05h1.53v-1.53h3.04v-1.52zm0-6.1v4.58h4.57v-1.53h-3.04v-1.52h3.04v-1.53zm3.05-4.57v-1.52h-3.05v4.57h4.57v-1.52h-3.04v-1.53zm-3.05-9.14h1.53V4.57h-1.53V6.1H16V4.57h1.52V3.05h-3.05v1.52h-1.52v3.05h1.52v1.52h3.05zm-3.05 22.86h3.05V32h-3.05Zm0-15.24h-3.04v1.52h1.52v13.72h1.52zM11.43 0h9.14v1.52h-9.14ZM9.9 13.71h1.53v1.53H9.9Zm0-12.19h1.53v1.53H9.9ZM8.38 12.19H9.9v1.52H8.38Zm0-9.14H9.9v1.52H8.38ZM6.86 4.57h1.52v7.62H6.86Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialKey
